import {useState} from 'react';
import {Navigate, useNavigate} from 'react-router-dom';
import {Button, Form, Input, message} from 'antd';

import logo from '../../assets/icon/l_logo.png';
import {apkLogin} from './apkApi';
import {setApkToken, isApkAuthenticated} from './apkAuth';
import './styles.less';

const ApkLoginPage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  if (isApkAuthenticated()) {
    return <Navigate to='/apk-distribution' replace />;
  }

  const handleSubmit = async ({username, password}) => {
    setLoading(true);
    try {
      const res = await apkLogin(username, password);
      const token = res?.data?.data?.token;
      if (!token) {
        message.error('Login failed: token missing in response');
        return;
      }
      setApkToken(token);
      navigate('/apk-distribution', {replace: true});
    } catch (err) {
      const msg =
        err?.response?.data?.message ||
        err?.response?.data?.msg ||
        'Invalid username or password';
      message.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='apk-login'>
      <div className='apk-login__card'>
        <div className='apk-login__logo'>
          <img src={logo} alt='Univision' />
        </div>

        <Form layout='vertical' onFinish={handleSubmit}>
          <Form.Item
            label={<span className='apk-login__label'>Username</span>}
            name='username'
            colon={false}
            rules={[{required: true, message: 'Username is required'}]}>
            <Input className='apk-login__input' />
          </Form.Item>

          <Form.Item
            label={<span className='apk-login__label'>Password</span>}
            name='password'
            colon={false}
            rules={[{required: true, message: 'Password is required'}]}>
            <Input.Password className='apk-login__password' />
          </Form.Item>

          <Form.Item style={{marginTop: 24}}>
            <Button
              type='primary'
              htmlType='submit'
              loading={loading}
              className='apk-login__submit'>
              Login
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default ApkLoginPage;
